import {Injectable} from "@angular/core";
import {Action, Selector, State, StateContext} from "@ngxs/store";
import {Setting} from "../models/setting.model";
import {GetSettingsAction} from "./settings.actions";
import {SettingsService} from "../services/settings.service";
import {tap} from "rxjs";

export interface SettingsStateModel {
    settings: Setting[]
}

@State<SettingsStateModel>({
    name: 'ParamsStore',
    defaults: {
        settings: []
    }
})

@Injectable()
export class SettingsState {
    constructor(private service: SettingsService) {
    }

    @Selector()
    static getAllSettings(state: SettingsStateModel) {
        return state.settings;
    }

    @Selector()
    static getStartDate(state: SettingsStateModel) {
        return state.settings?.find(setting => setting.key === 'HUB_SESSION_OPENING_DATE')?.value;
    }

    @Selector()
    static getEndDate(state: SettingsStateModel) {
        return state.settings?.find(setting => setting.key === 'HUB_SESSION_CLOSING_DATE')?.value;
    }

    /**
     * Get website settings
     * @param ctx StateContext<SettingsStateModel>
     * @returns all website settings
     */
    @Action(GetSettingsAction)
    getSettingsAction(ctx: StateContext<SettingsStateModel>) {
        return this.service.getAllSettings().pipe(tap(res => {
            const state = ctx.getState();
            ctx.setState({
                ...state,
                settings: res,
            })
        }))
    }
}
